<div class="p8-bdc_comment__container" fxLayout="column">
  <div class="p8-bdc_comment__title mat-subheading-1 p8-secondary">Avez-vous trouvé cet article utile ?</div>
  <div class="p8-bdc_comment__like-buttons" fxLayout="row" fxLayoutAlign="center">
    <button mat-icon-button (click)="saveNote(1)" matTooltip="Cet article m'est utile">
      <mat-icon [ngClass]="note === 1 ? 'p8-primary' : 'p8-secondary'" aria-label="Utile">thumb_up</mat-icon>
    </button>
    <div style="width: 50px;"></div>
    <button mat-icon-button (click)="saveNote(-1)" matTooltip="Cet article ne m' est pas utile">
      <mat-icon [ngClass]="note === -1 ? 'p8-primary' : 'p8-secondary'" aria-label="Pas utile">thumb_down</mat-icon>
    </button>
  </div>
  <!--style="border: red solid 1px"-->
  <div class="p8-bdc_comment__text-area" fxFlex="80" fxLayout="column" *ngIf="note !== 0 && ! disabled">
    <div fxFlex="100">
      <mat-form-field fxFlex="100" [appearance]="'outline'" [floatLabel]="'never'">
        <textarea matInput
                  matTextareaAutosize
                  matAutosizeMinRows="3"
                  placeholder="Comment pouvons-nous améliorer cet article ?"
                  [(ngModel)]="commentText"
                  name="comment">
        </textarea>
      </mat-form-field>
      <mat-hint align="end" *ngIf="commentText && commentText"><code>{{commentText.length}}</code></mat-hint>
    </div>
    <div fxFlexAlign="end">
      <button mat-raised-button
              type="submit"
              color="accent"
              (click)="saveComment()"
              [disabled]="! commentText"
              matTooltip="Envoyer votre appréciation"
      >ENVOYER</button>
    </div>
  </div>
</div>



